import { render, staticRenderFns } from "./Accountable.vue?vue&type=template&id=08b0bb45&scoped=true"
import script from "./Accountable.vue?vue&type=script&lang=js"
export * from "./Accountable.vue?vue&type=script&lang=js"
import style0 from "./Accountable.vue?vue&type=style&index=0&id=08b0bb45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0bb45",
  null
  
)

export default component.exports